import yup from './yup';

function initConfigs() {
  yup.init();
}

initConfigs();
